import React from "react";
import { Link } from "react-router-dom";
import MethodologyImg from "../../assets/TeachingMethodology.svg";
import girlChildImg from "../../assets/girlHead.svg";
import playImg from "../../assets/playredyellow.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const TeachingMethodology = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2500,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400, // Below 900px
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 1210, // Below 900px
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 1050, // Below 900px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 500, // Below 500px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 1000,
          cssEase: "linear",
        },
      },
    ],
  };
  return (
    <div className="flex lg:flex-row flex-col bg-[#ffdadb] sm:m-[2rem] lg:m-[4rem] py-[1rem] sm:py-[3rem] pb-[3rem] sm:pb-[2rem] sm:pr-[1rem] rounded-lg sm:rounded-[50px]">
      <div className="lg:max-w-[20%] lg:min-w-[20%] lg:w-[20%] pl-6 pr-4 pt-4 lg:mx-0 mx-auto lg:mb-0 mb-3">
        <img
          src={MethodologyImg}
          width={400}
          height={300}
          alt="teachingmethodology"
        />
        <img
          src={girlChildImg}
          width={200}
          height={250}
          alt="girlchild"
          className="lg:flex min-w-[200px] hidden"
        />
      </div>
      <div className="w-[80%] lg:w-[80%]  lg:mx-0 mx-auto overflow-hidden">
        <Slider {...settings} className="">
          <div className="flex relative min-w-[260px] max-w-[261px] group min-h-[350px] px-auto flex-col items-center text-center pt-[1rem] bg-[#ffafbb] px-[1rem] rounded-[30px] text-[1.5rem] text-[#5A5F9B] !font-semibold">
            <span className="text-[2rem]">REGGIO EMILIA</span>
            <p className="text-[1rem] text-black py-3">
              SOMETIMES THE BEST TEACHER IS
            </p>

            <div className="flex font-Wonderbar text-[32px] sm:text-[34px] mt-[6px] text-white justify-center lg:max-h-full max-h-[80px]">
              Environment
            </div>

            <Link
              to="/teachingMethod?id=1"
              className="absolute bottom-[6%] w-[194px] h-[3rem] rounded-[40px] items-center ml-[18px] justify-between px-3 bg-[#c6d770] !font-semibold text-xl group-hover:flex flex sm:hidden mt-4"
            >
              <button> LEARN MORE </button>
              <img src={playImg} className="size-[2rem]" alt="playredyellow" />
            </Link>
          </div>

          <div className="flex flex-col min-w-[260px] max-w-[261px] relative group min-h-[350px] items-center text-center bg-[#ffd5ff] h-full px-[1.5rem] py-[1rem] rounded-[30px] text-[1.5rem] text-[#5A5F9B] !font-semibold">
            <span className="text-[2rem]">MONTESSORI</span>
            <p className="text-[1rem] text-black py-3">GIVE CHILDREN</p>

            <div className="flex font-Wonderbar text-[34px] mt-[6px] text-white justify-center lg:max-h-full max-h-[80px]">
              Freedom
            </div>

            <p className="text-[1rem] text-black sm:py-2 max-w-[190px]">
              TO EXPLORE,
              <br />
              LEARNING WILL HAPPEN BY THE WAY.
            </p>

            <Link
              to="/teachingMethod?id=2"
              className="w-[194px] absolute bottom-[6%] ml-[10px] h-[3rem] rounded-[40px] items-center justify-between px-3 bg-[#c6d770] !font-semibold text-xl group-hover:flex flex sm:hidden mt-4"
            >
              <button> LEARN MORE </button>
              <img src={playImg} className="size-[2rem]" alt="playredyellow" />
            </Link>
          </div>

          <div className="bg-[#e7dcff] min-w-[260px] max-w-[261px] group relative h-full min-h-[350px] px-[1.5rem] py-[1rem] rounded-[30px] text-[1.5rem] text-[#5A5F9B] !font-semibold flex flex-col items-center text-center">
            <span className="text-[2rem]">PLAY-BASED LEARNING</span>

            <p className="text-[1rem] text-black py-2">
              BECAUSE WHEN <br /> CHILDREN
            </p>

            <div className="flex font-Wonderbar text-[34px] mt-[4px] text-white justify-center lg:max-h-full max-h-[80px]">
              Play
            </div>

            <p className="text-[1rem] text-black py-2">THEY LEARN TOO.</p>

            <Link
              to="/teachingMethod?id=3"
              className="absolute bottom-2 lg:bottom-[6%] ml-[10px] w-[194px] h-[3rem] rounded-[40px] items-center justify-between px-3 bg-[#c6d770] !font-semibold text-xl group-hover:flex flex sm:hidden"
            >
              <button>LEARN MORE</button>
              <img src={playImg} className="size-[2rem]" alt="playredyellow" />
            </Link>
          </div>

          <div className="bg-[#c4dbff] min-w-[260px] max-w-[261px] relative h-full min-h-[350px] px-[0.7rem] py-[1rem] rounded-[30px] text-[1.5rem] text-[#5A5F9B] !font-semibold group flex flex-col items-center text-center">
            <span className="text-[1.8rem]">EXPERIENTIAL LEARNING</span>

            <p className="text-[1rem] text-black py-3">LEARNING BY DOING IS</p>

            <div className="flex font-Wonderbar text-[34px] mt-[6px] text-white justify-center lg:max-h-full max-h-[80px]">
              Learning
            </div>

            <p className="text-[1rem] text-black py-3">FOR LIFE.</p>

            <Link
              to="/teachingMethod?id=4"
              className="absolute bottom-[6%] w-[194px] ml-[20px] h-[3rem] rounded-[40px] items-center justify-between px-3 bg-[#c6d770] !font-semibold text-xl group-hover:flex flex sm:hidden mt-4"
            >
              <button> LEARN MORE </button>
              <img src={playImg} className="size-[2rem]" alt="playredyellow" />
            </Link>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default TeachingMethodology;
